/* eslint-disable */
import { utils, writeFileXLSX } from "xlsx";

export function downloadExcel(array, fileName = "Reportes") {
  const ws = utils.json_to_sheet(array);
  const wb = utils.book_new();
  utils.book_append_sheet(wb, ws, "Data");
  writeFileXLSX(wb, `${fileName}-${new Date().toLocaleString().split(",")[0]}.xlsx`);
}
